import { ref, watch } from 'vue'
import { useAuth, useClerk } from '@clerk/vue'
import { useComposition } from '@/compositions/composition'
import { exchangeClerkToken, friendlyError, redirectHome } from './sessionApi'

function hasAppUser(user) {
  return user && Object.prototype.hasOwnProperty.call(user, 'id')
}

/**
 * When Clerk reports signed-in, exchange JWT for PHP session once.
 * UI components only display bridgeError — no Clerk/API details.
 */
export function useClerkBridge() {
  const { global } = useComposition()
  const clerk = useClerk()
  const { isSignedIn, getToken, isLoaded } = useAuth()
  const bridging = ref(false)
  const bridgeError = ref('')

  const bridge = async () => {
    if (bridging.value || !isSignedIn.value || hasAppUser(global.value.user)) {
      return
    }

    bridging.value = true
    bridgeError.value = ''

    try {
      const token = await getToken.value()
      if (!token) {
        throw new Error('Mangler Clerk-token')
      }

      const data = await exchangeClerkToken(token)
      if (data && data.success) {
        redirectHome()
        return
      }

      bridgeError.value = (data && data.friendly && data.friendly.da) || 'Google-login fejlede.'
      await safeClerkSignOut(clerk)
    } catch (error) {
      bridgeError.value = friendlyError(
        error,
        'Google-login fejlede. Er din e-mail oprettet som medlem?'
      )
      await safeClerkSignOut(clerk)
    } finally {
      bridging.value = false
    }
  }

  watch(
    [isLoaded, isSignedIn],
    ([loaded, signedIn]) => {
      if (loaded && signedIn) {
        bridge()
      }
    },
    { immediate: true }
  )

  return { bridgeError, bridging }
}

async function safeClerkSignOut(clerk) {
  try {
    if (clerk.value && typeof clerk.value.signOut === 'function') {
      await clerk.value.signOut()
    }
  } catch (e) {
    // ignore
  }
}
